const logout = () => {
	localStorage.clear();
	window.location.reload(false);
};

export { logout };
